import { useEffect, useState } from 'react';

import { getImageBottomColor } from 'js/app/utils/getImageBottomColor';

export const useDetectImageColor = ({ imageRef }) => {
    const [color, setColor] = useState();

    useEffect(() => {
        const el = imageRef?.current;
        const handlerSetBottomColor = () => {
            setColor(getImageBottomColor(el));
        };

        if (!el) {
            return;
        }

        if (el.complete) {
            handlerSetBottomColor();
        }

        el?.addEventListener('load', handlerSetBottomColor);

        return () => {
            el?.removeEventListener('load', handlerSetBottomColor);
        };
    }, [imageRef]);

    return color;
};

